import React, { Component } from 'react';
import { Modal } from 'antd';
import api from '../api/index';
import { UserContext } from '../UserContext';
// import PhoneInput from 'react-phone-input-2'
// import 'react-phone-input-2/lib/style.css'
import { withRouter } from '../utils/withRouter';
import LoadingComponent from './LoadingComponent';

class EditAccountSettings extends Component {
  static contextType = UserContext;

  state = {
    name: '',
    // phone: '',
    email: '',
    isUploading: false,
  };

  handleUpdate = (newData) => {
    const { user, setUser } = this.context;

    const updatedFields = {};

    if (
      newData.name !== undefined &&
      newData.name !== "" &&
      newData.name !== user.name
    ) {
      updatedFields.name = newData.name;
    }

    // if (
    //   newData.phone !== undefined &&
    //   newData.phone !== "" &&
    //   newData.phone !== user.phone
    // ) {
    //   updatedFields.phone = newData.phone;
    // }

    if (
      newData.email !== undefined &&
      newData.email !== "" &&
      newData.email !== user.email
    ) {
      updatedFields.email = newData.email;
    }

    if (Object.keys(updatedFields).length > 0) {
      const updatedUser = {
        ...user,
        ...updatedFields,
      };
      setUser(updatedUser);
    }
  };

handleAccountSettingsChange = () => {

  const { name, email } = this.state;

  if (!name && !email) {
    Modal.info({
      title: 'No Changes',
      content: "You haven't made any changes to save.",
    });
    return;
  }

  this.setState({ isUploading: true });

  const formData = {
    access_token: this.context.user.access_token,
    id: this.context.user.id
  };
  if (name) formData.name = name;
  // if (phone) formData.phone = phone;
  if (email) formData.email = email;

  fetch(`${api.main}api/auth/edit_account_settings`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(formData)
  })

    .then((response) => {
      if (!response.ok) {
        throw new Error(`Server returned ${response.status}: ${response.statusText}`);
      }
      return response.json();
    })
    .then((data) => {
      this.setState({ isUploading: false });
      this.handleUpdate({name, email});

      Modal.success({
        title: 'Account Updated',
        content: data.message || 'Your account has been successfully updated!',
        centered: true,
        onOk: () => {
          window.location.reload();
        }
      });
    })

    .catch((error) => {
      this.setState({ isUploading: false });
      Modal.error({
        title: 'Error',
        content: error.message || 'Failed to update account. Please try again.',
      });
    });
};

  render() {
    const { name, email, loading, isUploading } = this.state;
    const user = this.context.user;
    if (loading) {
      return (
        <div className="container mt-4">
          <div className="profile-container d-flex flex-column align-items-center" style={{ maxWidth: "600px", width: "100%", margin: "0 auto" }}>
            <LoadingComponent />
          </div>
        </div>
      );
    }

    return (
      <div>
        <div className="account-settings">
          <h2>Edit Account Details</h2>
          <div className="account-section">
            <div className="account-item">
                <label htmlFor="name">Name: </label>
                <input
                  type="text"
                  id="name"
                  className="account-input"
                  placeholder={user.name}
                  value={name}
                  onChange={(e) => this.setState({ name: e.target.value })}
                />
            </div>
          </div>
          {/* <div className="account-section">
            <div className="account-item">
                <label htmlFor="phone">Phone Number: </label>
                <PhoneInput
                  className="account-input"
                  style={{padding: "0px"}}
                  country={"us"}
                  value={user.phone}
                  inputProps={{name: "phone"}}
                  onChange={(value) => this.setState({ phone: "+" + value })}
                />
            </div>
          </div> */}
          <div className="account-section">
            <div className="account-item">
                <label htmlFor="email">Email: </label>
                <input
                  type="email"
                  id="email"
                  className="account-input"
                  placeholder={user.email}
                  value={email}
                  onChange={(e) => this.setState({ email: e.target.value })}
                />
            </div>
          </div>
          <div className="account-section">
            <div className="account-item" style={{justifyContent: "space-evenly", flexDirection: "row-reverse"}}>
              <button
                  className="btn btn-primary"
                  style={{width:"200px"}}
                  onClick={this.handleAccountSettingsChange}
                  disabled={isUploading}
                >
                  {isUploading ? 'Saving...' : 'Save'}
                </button>
              </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(EditAccountSettings);
